import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { requestPasswordReset } = useAuth();

  const onChange = e => {
    setEmail(e.target.value);
  };

  const onSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setMessage('');

    if (!email) {
      setError('이메일을 입력해주세요.');
      setIsLoading(false);
      return;
    }

    try {
      const result = await requestPasswordReset(email);
      if (result.success) {
        setMessage(result.message || '비밀번호 재설정 링크가 이메일로 전송되었습니다.');
        setIsSubmitted(true);
      } else {
        setError(result.message || '비밀번호 재설정 요청 중 오류가 발생했습니다.');
      }
    } catch (err) {
      setError('서버 오류가 발생했습니다. 나중에 다시 시도해주세요.');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-form-container">
        <h2>비밀번호 찾기</h2>
        {error && <div className="alert alert-danger">{error}</div>}
        {message && <div className="alert alert-success">{message}</div>}
        
        {!isSubmitted ? (
          <>
            <p className="instruction-text">
              가입 시 사용한 이메일 주소를 입력하시면, 비밀번호 재설정 링크를 보내드립니다.
            </p>
            <form onSubmit={onSubmit}>
              <div className="form-group">
                <label htmlFor="email">이메일</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={onChange}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary" disabled={isLoading}>
                {isLoading ? '처리 중...' : '비밀번호 재설정 링크 받기'}
              </button>
            </form>
          </>
        ) : (
          <div className="success-message">
            <p>
              비밀번호 재설정 링크가 이메일로 전송되었습니다. 이메일을 확인해주세요.
            </p>
            <p>
              이메일이 도착하지 않았다면 스팸 메일함을 확인하거나, 다시 시도해주세요.
            </p>
            <button 
              className="btn btn-secondary" 
              onClick={() => {
                setIsSubmitted(false);
                setMessage('');
              }}
            >
              다시 시도
            </button>
          </div>
        )}
        
        <div className="forgot-password-links">
          <Link to="/login">로그인 페이지로 돌아가기</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword; 